import { DefaultTheme, withTheme } from 'styled-components';
import { Row } from 'antd';

import useI18n from '../../common/hooks/useI18n';

import SectionTitle from './sectionTitle';
import WhySellWithUsProperty from './whySellWithUsProperty';

type Props = {
  query: string;
  theme: DefaultTheme;
};

const WhySellWithUs: React.FC<Props> = ({ query, theme }) => {
  const i18n = useI18n();

  return (
    <>
      <SectionTitle
        title={i18n.t(`dynamic.sellHousePage.${query}.whySellWithUsTitle`)}
      />
      <Row gutter={[64, 32]}>
        <WhySellWithUsProperty property="fast" query={query} theme={theme} />
        <WhySellWithUsProperty
          property="promotion"
          query={query}
          theme={theme}
        />
        <WhySellWithUsProperty
          property="specialists"
          query={query}
          theme={theme}
        />
        <WhySellWithUsProperty property="finance" query={query} theme={theme} />
        <WhySellWithUsProperty property="leader" query={query} theme={theme} />
        <WhySellWithUsProperty
          property="implication"
          query={query}
          theme={theme}
        />
      </Row>
    </>
  );
};

export default withTheme(WhySellWithUs);
